import { render } from "./HomeReports.vue?vue&type=template&id=45b0735c&scoped=true"
import script from "./HomeReports.vue?vue&type=script&lang=js"
export * from "./HomeReports.vue?vue&type=script&lang=js"

import "./HomeReports.vue?vue&type=style&index=0&id=45b0735c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jhunr\\Documents\\Work\\GCM3\\repos\\talentsage2026\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45b0735c"]])

export default __exports__